/* 同级对比 */
import React from 'react'
import Link from 'next/link'
import Image from 'Components/image'
import Tab from './common/tab'
import { sendTeaCommEvent } from 'lib/tea-analyze'

import getLinkHref from 'lib/get-link-href'
import Button from 'Components/button'

export interface IPk {
  series_id: number
  series_name: string
  price: string
  cover_image: string
}

interface IProps {
  seriesId: number
  compare: IPk[]
  className?: string
}

export default function Pk({ seriesId, compare, className }: IProps) {
  return (
    <section className={className}>
      <Tab leftContent="同级对比" />
      <div className="list">
        {compare.slice(0, 3).map((item: IPk) => (
          <a
            key={item.series_name}
            href={`/auto/series/${item.series_id}`}
            //  eslint-disable-next-line react/jsx-no-target-blank
            target="_blank"
          >
            <div
              className="box"
              onClick={() => {
                sendTeaCommEvent('click_same_series_card', {
                  car_series_id: item.series_id,
                })
              }}
            >
              <div className="cover fl">
                <Image src={item.cover_image} />
              </div>
              <div className="info fl">
                <p className="name line-1">{item.series_name}</p>
                <p className="price line-1">{item.price}</p>
              </div>
              <Button
                className="button fl"
                type="new_primary"
                onClick={eve => {
                  eve.preventDefault()
                  sendTeaCommEvent('click_same_series_btn', {
                    car_series_id: item.series_id,
                    click_same_series_btn: '对比',
                  })
                  window.open(
                    `/auto/compare/${seriesId},${item.series_id}`,
                    '_blank'
                  )
                }}
              >
                对比
              </Button>
            </div>
          </a>
        ))}
      </div>
      <style jsx>
        {`
          section {
            background-color: #ffffff;
            width: 320px;
          }
          .list {
            padding: 0 16px;
          }
          .box {
            display: flex;
            align-items: center;
            width: 100%;
            height: 92px;
            border-bottom: solid 1px #f2f4fa;
            cursor: pointer;
          }

          .box:last-child {
            margin-right: 0;
          }
          .cover {
            width: 95px;
            height: 63px;
            flex-shrink: 0;
          }
          .cover :global(span) {
            background-size: contain;
          }
          .info {
            width: 173px;
            margin: 0 8px;
            flex: 1;
          }

          .name {
            width: 120px;
            font-size: 14px;
            color: #1f2129;
            letter-spacing: 0;
            font-weight: 500;
          }
          .price {
            margin-top: 4px;
            font-size: 12px;
            color: #e62021;
            letter-spacing: 0;
            line-height: 18px;
            font-weight: 500;
          }
          .button {
            width: 60px;
            height: 28px;
            text-align: center;
            line-height: 28px;
            font-size: 16px;
            flex-shrink: 0;
          }
        `}
      </style>
    </section>
  )
}
